module.exports = __webpack_public_path__ + "media/images/help/site-create-eaa808264ba2e91a4ee4d0dcddfab2f4.png";